/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_TargetInputs */

const en_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Target`)
};

const es_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar destino`)
};

const fr_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier la cible`)
};

const de_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel kopieren`)
};

const ja_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲットをコピー`)
};

const zh_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制目标`)
};

const ar_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخ الهدف`)
};

const id_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin Target`)
};

const it_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia Destinazione`)
};

const ru_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копировать цель`)
};

const pt_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar Alvo`)
};

const ko_copy_target = /** @type {(inputs: Copy_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대상 복사`)
};

/**
* | output |
* | --- |
* | "Copy Target" |
*
* @param {Copy_TargetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const copy_target = /** @type {((inputs?: Copy_TargetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_TargetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_copy_target(inputs)
	if (locale === "es") return es_copy_target(inputs)
	if (locale === "fr") return fr_copy_target(inputs)
	if (locale === "de") return de_copy_target(inputs)
	if (locale === "ja") return ja_copy_target(inputs)
	if (locale === "zh") return zh_copy_target(inputs)
	if (locale === "ar") return ar_copy_target(inputs)
	if (locale === "id") return id_copy_target(inputs)
	if (locale === "it") return it_copy_target(inputs)
	if (locale === "ru") return ru_copy_target(inputs)
	if (locale === "pt") return pt_copy_target(inputs)
	return ko_copy_target(inputs)
});